/** Human-readable label for prompt template document_type (same as filters / Prompt Manager). */
export function formatDocumentTypeLabel(documentType) {
  const value = (documentType || '').trim();
  if (!value) return '';
  return value
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
